import * as localGdeTransactionLite from '../firestore/localGdeTransactionsLite'
import * as constants from '../../irmlib/src/common/constants'

/**
 * Deletes captured NATS asset images when box reopened.
 */
export async function deleteNatsCapturedImagesForBox(natsService, rowData) {
  const activityId = rowData?.activityId
  const skpBoxNbr = rowData?.boxId

  if (!natsService || !activityId || !skpBoxNbr) {
    return
  }

  const snap = await localGdeTransactionLite.getImages(activityId, skpBoxNbr)
  const keys = []
  snap?.docs?.forEach((docSnap) => {
    const paths = docSnap.data()?.imgDetails?.imgPath
    if (!Array.isArray(paths)) {
      return
    }
    paths.forEach((p) => {
      const isCapturedNatsAsset =
        typeof p === 'string' &&
        p.length > 0 &&
        !p.startsWith('http') &&
        !p.startsWith('data:') &&
        p.includes('nats_assetImg')
      if (isCapturedNatsAsset) {
        keys.push(p.trim())
      }
    })
  })

  const uniqueKeys = [...new Set(keys)]
  const bucket = constants.LOCAL_AI_ASSET_IMG
  for (const key of uniqueKeys) {
    await natsService.deleteObjectFromNats(constants.LOCAL_NATS_SERVER, bucket, key, { silent: true })
  }
}
